import React, {useState, useEffect, useRef} from "react";
import {
    CustomButton,
    ToastNotification,
    ProgressLoader,
    InputTextCustomer,
    Select
} from "components/shared";
import validator from 'validator'
import './admin.css';
import 'primeflex/primeflex.css';
import {UsersService} from "services/http";
import UsersInit from './init'
import {CalendarCustomer, Discard} from "../../shared";

export function Register(props) {
    const [error, setError] = useState(UsersInit.getError())
    const [data, setData] = useState(UsersInit.getData())
    const [render, setRender] = useState(true)
    const [loading, setLoading] = useState(false)
    const [reset, setReset] = useState(false)
    const [affiliations, setAffiliations] = useState()
    const childRef = useRef();

    useEffect(() => {
        setLoading(true);
        UsersService.getUserAffiliations().then(data => {
            setAffiliations(data.result);
            setLoading(false);
        }, error => {
            childRef?.current?.showToast({type: "warn", title: "Error response", message: error, durable: true});
        });
    }, []);

    useEffect(() => {
        setRender(data.typeAuth === '1')
        if (render) {
            setError(prevState => {
                return {...prevState, ['password']: '', ['confirmPwd']: ''}
            });
        }
    }, [data.typeAuth]);

    useEffect(() => {
        setData(UsersInit.getData());
        setError(UsersInit.getError());
        //  setRender(data.typeAuth === 1);
        setLoading(false);
    }, [reset]);

    const _validateEmail = (e) => {
        if (e.target.value.length != 0) {
            if (!validator.isEmail(e.target.value)) {
                setError(prevState => {
                    return {...prevState, [e.target.name]: 'Enter valid Email!'}
                });
            } else {
                setError(prevState => {
                    return {...prevState, [e.target.name]: ''}
                });
            }
        } else {
            setError(prevState => {
                return {...prevState, [e.target.name]: ''}
            });
        }
    }
    const _validatePhone = (e) => {
        var pattern = new RegExp(/^[0-9\b]+$/);
        if (e.target.value.length != 0) {
            if (!pattern.test(e.target.value)) {
                setError(prevState => {
                    return {...prevState, [e.target.name]: 'Please enter only number.!'}
                });

            } else {
                if (e.target.value.length != 10) {
                    setError(prevState => {
                        return {...prevState, [e.target.name]: 'Please enter valid phone number.!'}
                    });
                } else {
                    setError(prevState => {
                        return {...prevState, [e.target.name]: ''}
                    });
                }
            }
        } else {
            setError(prevState => {
                return {...prevState, [e.target.name]: ''}
            });
        }
    }

    function _validateRequired(name) {
        if (data[name]?.length === 0) {
            setError(prevState => {
                return {...prevState, [name]: 'Please fill in this field.!'}
            });
            return false;
        } else {
            setError(prevState => {
                return {...prevState, [name]: ''}
            });
            return true;
        }
    }

    function _validateError() {
        if (error.phoneNumber1
            || error.phoneNumber2
            || error.email
            || error.password) {
            return false;
        } else {
            return true;
        }
    }

    const _validatePwd = (e) => {
        if (data.password) {
            if (data.password < 8) {
                setError(prevState => {
                    setError(prevState => {
                        return {
                            ...prevState,
                            ['passwordFirst']: 'The Pwd must have a minimum of 8 characters'
                        }
                    });
                });
            } else if (data.password.match(/([A-Z]+)/g) === null) {
                setError(prevState => {
                    setError(prevState => {
                        return {
                            ...prevState,
                            ['passwordFirst']: 'The Pwd must have at least 1 capital letter'
                        }
                    });
                });
            } else if (data.password.match(/([*^$@_#&./:?!=+%]+)/g) === null) {
                setError(prevState => {
                    setError(prevState => {
                        return {
                            ...prevState,
                            ['passwordFirst']: 'The Pwd must have at least 1 special character'
                        }
                    });
                });
            } else if (data.password.match(/([1-9]+)/g) === null){
                setError(prevState => {
                    setError(prevState => {
                        return {
                            ...prevState,
                            ['passwordFirst']: 'The Pwd must have at least 1 number'
                        }
                    });
                });

            }else
                setError(prevState => {
                    return {...prevState, ['passwordFirst']: ''}
                });
        }
    }
    const _validateConfirmPwd = (e) => {
        _validatePwd(e)
        if (data.confirmPwd) {
            if (data.password !== data.confirmPwd) {
                setError(prevState => {
                    setError(prevState => {
                        return {...prevState, ['password']: ' Password does not match!'}
                    });
                });
            } else {
                setError(prevState => {
                    return {...prevState, ['password']: ''}
                });
            }
        }
    }

    function _handleChange(e) {
        setData(prevState => {
            return {...prevState, [e.target.name]: e.target.value}
        });
        _validateConfirmPwd()
    }

    function _handleChangeMap(name, value) {
        setData(prevState => {
            return {...prevState, [name]: value}
        });
    }

    function _reset(e) {
        setLoading(true);
        setReset(!reset)
    }

    function _submit(e) {
        e.preventDefault();
        const _valid = _validateError();
        if (_validateRequired('teams') &&
            _validateRequired('roles') &&
            _validateRequired('competences') &&
            _validateRequired('languages') &&
            _valid) {
            setLoading(true);
            UsersService.submitUserAdd(data).then(data => {
                setLoading(false);
                childRef?.current?.showToast({
                    type: "success",
                    title: "Success response",
                    message: data.message,
                    durable: false
                });
                props.refresh();
            }, error => {
                setLoading(false);
                childRef?.current?.showToast({
                    type: "warn",
                    title: "Error response",
                    message: error, durable: false
                });
            });
        }
    }


    return (
        <div>
            {loading ? <ProgressLoader/> :
                <form onSubmit={_submit}>
                    <div className="p-grid p-justify-center p-align-center">
                        <div className="p-col-10 p-fluid">
                            <div className="p-grid">
                                <div className=" p-col-6">
                                    <Select
                                        id="typeAuth"
                                        label='Type Authentication'
                                        select='single'
                                        name='typeAuth'
                                        value={data.typeAuth}
                                        options={[
                                            {"description": 'LDAP', "value": '1'},
                                            {"description": 'Base de données', "value": '0'}
                                        ]}
                                        icon="pi pi-th-large"
                                        onChange={_handleChange}
                                        required={true}
                                        filter={false}
                                        optionLabel='description'
                                        // item='value'
                                    />
                                </div>
                                <div className=" p-col-6">
                                    <InputTextCustomer id="username" name='username'
                                                       onChange={_handleChange}
                                                       type="text" label='Username'
                                                       required={true}
                                                       icon="pi pi-user-edit"
                                                       value={data.username}/>
                                </div>
                                {!render ?
                                    <div className=" p-col-6">
                                        <InputTextCustomer id="firstName" name='firstName'
                                                           onChange={_handleChange}
                                                           type="text" label='Firstname'
                                                           icon="pi pi-user"
                                                           value={data.firstName}/>
                                    </div> : ''}
                                {!render ? <div className=" p-col-6">
                                    <InputTextCustomer id="lastName" name='lastName'
                                                       onChange={_handleChange}
                                                       type="text" label='Lastname'
                                                       icon="pi pi-user"
                                                       value={data.lastName}/>

                                </div> : ''}
                                {!render ? <div className=" p-col-6">
                                    <InputTextCustomer id="phoneNumber1" name='phoneNumber1'
                                                       onChange={_handleChange}
                                                       type="text" label='Phone Number1 '
                                                       icon="pi pi-phone"
                                                       onBlur={_validatePhone}
                                                       validate={error?.phoneNumber1}
                                                       value={data.phoneNumber1}/>
                                </div> : ''}
                                {!render ? <div className=" p-col-6">
                                    <InputTextCustomer id="phoneNumber2" name='phoneNumber2'
                                                       onChange={_handleChange}
                                                       type="text" label='Phone Number2 '
                                                       icon="pi pi-phone"
                                                       onBlur={_validatePhone}
                                                       validate={error?.phoneNumber2}
                                                       value={data.phoneNumber2}/>
                                </div> : ''}
                                {!render ? <div className=" p-col-6">
                                    <InputTextCustomer id="email" name='email'
                                                       onChange={_handleChange}
                                                       type="text" label='Email'
                                                       icon="pi pi-envelope"
                                                       onBlur={_validateEmail}
                                                       validate={error?.email}
                                                       value={data.email}/>
                                </div> : ''}
                                <div className=" p-col-6">
                                    <Select
                                        id="teams"
                                        label='Teams'
                                        select='multiple'
                                        name='teams'
                                        icon="pi pi-slack"
                                        required={true}
                                        value={data.teams}
                                        options={affiliations?.teams}
                                        optionLabel='description'
                                        filterBy='description'
                                        item='teamId'
                                        onChange={_handleChangeMap}
                                        validate={error?.teams}
                                    />
                                </div>
                                <div className=" p-col-6">
                                    <Select
                                        id="enabled"
                                        label='Enabled'
                                        select='single'
                                        name='enabled'
                                        value={data.enabled + ''}
                                        options={[
                                            {"description": 'Enable', "value": '1'},
                                            {"description": 'Disable', "value": '0'}
                                        ]}
                                        icon="pi pi-cog"
                                        onChange={_handleChange}
                                        required={true}
                                        filter={false}
                                        optionLabel='description'
                                        text='number'
                                        // item='value'
                                    />
                                </div>
                                <div className=" p-col-6">
                                    <Select
                                        id="roles"
                                        label='Roles'
                                        select='multiple'
                                        name='roles'
                                        icon="pi pi-wallet"
                                        required={true}
                                        value={data.roles}
                                        options={affiliations?.roles}
                                        optionLabel='roleDescription'
                                        item='roleId'
                                        filterBy='roleDescription'
                                        onChange={_handleChangeMap}
                                        validate={error?.roles}
                                    />
                                </div>
                                {!render&&<div className=" p-col-6">
                                    <CalendarCustomer id="expiryDate"
                                                      name='expiryDate'
                                                      onChange={_handleChange}
                                                      type="Date"
                                                      min={new Date()}
                                                      format="yyyy/mm/dd"
                                                      label='Expiry date'
                                                      icon="pi pi-calendar"
                                                      required={!render}
                                                      value={data.expiryDate}/>
                                </div>}
                                <div className=" p-col-6">
                                    <Select
                                        id="competences"
                                        label='Competences'
                                        select='multiple'
                                        name='competences'
                                        icon="pi pi-ticket"
                                        required={true}
                                        value={data.competences}
                                        options={affiliations?.competences}
                                        optionLabel='description'
                                        filterBy='description'
                                        item='competenceId'
                                        onChange={_handleChangeMap}
                                        validate={error?.competences}
                                    />
                                </div>
                                <div className=" p-col-6">
                                    <InputTextCustomer id="capacityNormal" name='capacityNormal'
                                                       onChange={_handleChange}
                                                       type="Number" label='Capacity normal'
                                                       icon="pi pi-user-minus"
                                                       required={true}
                                                       min={0}
                                                       value={data.capacityNormal}/>
                                </div>
                                <div className=" p-col-6">
                                    <InputTextCustomer id="capacityMax" name='capacityMax'
                                                       onChange={_handleChange}
                                                       type="Number" label='Capacity max'
                                                       icon="pi pi-user-plus"
                                                       required={true}
                                                       min={0}
                                                       value={data.capacityMax}/>
                                </div>
                                <div className=" p-col-6">
                                    <Select
                                        id="languages"
                                        label='Languages'
                                        select='multiple'
                                        name='languages'
                                        icon="pi pi-slack"
                                        required
                                        value={data?.languages}
                                        options={affiliations?.languages}
                                        optionLabel='description'
                                        filterBy='description'
                                        item='languageId'
                                        onChange={_handleChangeMap}
                                        validate={error?.languages}
                                    />
                                </div>
                                <div className=" p-col-6">
                                </div>
                                {!render ?
                                    <div className=" p-col-6">
                                        <InputTextCustomer id="password" name='password'
                                                           onChange={_handleChange}
                                                           type="password" label='Password'
                                                           required={true}
                                                           autocomplete="new-password"
                                                           autocapitalize="off"
                                                           autocorrect="off"
                                                           icon="pi pi-lock"
                                                           //onFocus={_validatePwd}
                                                           validate={error?.passwordFirst}
                                                           value={data.password}/>
                                    </div> : ''}
                                {!render ? <div className=" p-col-6">
                                    <InputTextCustomer id="confirm-password" name='confirmPwd'
                                                       onChange={_handleChange}
                                                       type="password" label='Confirm Password'
                                                       autocomplete="new-password"
                                                       icon="pi pi-lock"
                                                       autocapitalize="off"
                                                       autocorrect="off"
                                                       noShow={true}
                                                       required={true}
                                                       onBlur={_validateConfirmPwd}
                                                       value={data.confirmPwd}
                                                       validate={error?.password}/>
                                </div> : ''}
                                <div className=" p-col-12"/>
                                <div className=" p-col-12"/>
                                <div className=" p-col-6"/>
                                <div className=" p-col-3">
                                    <Discard onClick={_reset}/>
                                </div>
                                <div className=" p-col-3">
                                    <CustomButton
                                        label="Submit"
                                        icon="bi bi-check-circle-fill"
                                        type='Submit'
                                        className="p-button-danger btc"
                                    />
                                </div>

                            </div>
                        </div>
                    </div>

                </form>
            }

            <ToastNotification ref={childRef}/>
        </div>
    );
}
